import { api } from './apiClient';
import type { BlockDocument } from '../cms/BlockRenderer';
import type { GlobalSectionMap } from '../cms/globalSections';
import type { ResolvedTheme } from '../cms/ThemeProvider';

/** What the public resolver returns. Deliberately narrow — no drafts, no internal ids. */
export interface ResolvedCmsPage {
  resolved: true;
  source: 'page_override' | 'assigned_template' | 'organization_default' | 'platform_default';
  version: number;
  document: BlockDocument;
  seo: { title: string | null; description: string | null; ogImageAssetId: string | null };
  /**
   * Everything else the page needs, bundled into this one answer.
   *
   * A page that fetched its theme and then each referenced section separately would
   * make four round trips before it could draw, and five the moment somebody added a
   * sponsor strip. Both are optional: an older engine, or a cached response from
   * before this shipped, simply omits them and the page renders exactly as it did.
   */
  globalSections?: GlobalSectionMap;
  theme?: ResolvedTheme;
}

export type CmsResolution = ResolvedCmsPage | { resolved: false };

/**
 * Resolve an entity's CMS document.
 *
 * `{ resolved: false }` is a NORMAL answer, not an error: it means no CMS document is
 * configured and the caller should render the page it has always rendered.
 */
export const resolveEventPage = (eventId: string) =>
  api.get<CmsResolution>(`/cms/resolve?entity=event&id=${encodeURIComponent(eventId)}`);
